import React from "react";
import { ProjectTaskDashboardViewer } from "./ProjectTaskDashboardViewer";
import { ProjectTaskDashboardProvider } from "./context";

export const ProjectViewerDashboard = () => {
  return (
    <ProjectTaskDashboardProvider>
      <ProjectTaskDashboardViewer />
    </ProjectTaskDashboardProvider>
  );
};
